module.exports = __webpack_public_path__ + "img/jujue.3d6ba597.png";